import React from "react";
import FormField from "./FormField.jsx";

const OPTIONS = ["Good", "Bad", "Poor"];

export default function CreditHistoryField({
  id,
  value,
  error,
  touched,
  onChange,
  register,
}) {
  return (
    <FormField
      id={id}
      label="Credit History"
      required
      error={error}
      touched={touched}
    >
      <div className="flex flex-wrap gap-3" role="radiogroup" aria-label="Credit History">
        {OPTIONS.map((opt) => (
          <label
            key={opt}
            className={`px-4 py-2 rounded-full border cursor-pointer ${
              value === opt
                ? "bg-sky-400 text-white border-sky-400"
                : "bg-white text-slate-700 border-slate-200"
            }`}
          >
            {register ? (
              <input type="radio" value={opt} className="hidden" {...register} />
            ) : (
              <input
                type="radio"
                name={id}
                value={opt}
                className="hidden"
                checked={value === opt}
                onChange={() => onChange?.(opt)}
              />
            )}
            {opt}
          </label>
        ))}
      </div>
    </FormField>
  );
}
